// extracted by mini-css-extract-plugin
export var cardIcon = "_a8-4";
export var checkboxCard = "_a8-0";
export var checkboxCardSelected = "_a8-1";
export var disabled = "_a8-2";
export var outerBorder = "_a8-3";
export var spacerMedium = "_a8-7";
export var spacerSmall = "_a8-6";
export var spacerXsmall = "_a8-5";